<template>
  <div class="m-3">
    <div class="row ms-0">
      <div class="col-6 card tree-container">
      <AlertDismiss class="sticky mt-2" ref="alertDismissManagedCompanies"></AlertDismiss>
        <div v-if="managedCompanies !== null">
          <b-overlay :show="disabled">
            <NestedDraggable
                :node="managedCompanies"
                :currentSelection="currenSelection"
                :srcDragId="srcDragId"
            />
          </b-overlay>
        </div>
        <div v-else class="m-3 fs-6 align-middle text-secondary">
          <b-spinner small class="align-middle"></b-spinner>
          Cargando estructura...
        </div>
      </div>

      <div class="col-6">
        <LegalEntitiesList/>
      </div>
    </div>

  </div>
</template>

<script>
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import { mapActions } from 'vuex'
import NestedDraggable from "@/components/ManagedCompanies/ShareholdersStructure/Nested-draggable.vue";
import {EventNames} from "@/plugins/enums";
import LegalEntitiesList from "./ShareholdersStructure/Legal-entities-list.vue";

export default {
  name: 'Shareholders-structure',

  components: {
    NestedDraggable,
    AlertDismiss,
    LegalEntitiesList,
  },

  data() {
    return {
      disabled: false,
      managedCompanies: null,
      currenSelection: '',
      dragCounter: 0,
      isDragging: false,
      srcDragId: null
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.UpdateShareholderStructure, async () => {
      await this.getManagedCompaniesStructure()
    })

    this.$eventBus.$on(EventNames.ShowAlertManagedCompanies, async (data) => {
      this.$refs.alertDismissManagedCompanies.showAlert(data.msg, data.type);
    })

    this.$eventBus.$on(EventNames.ClickManagedCompany, (data) => {
      this.currenSelection = data.id;
    })

    this.$eventBus.$on(EventNames.UpdateLegalEntities, async () => {
      await this.getManagedCompaniesStructure();
    })

    this.$eventBus.$on(EventNames.StartDragShareholder, (id) => {
      this.srcDragId = id
    })

    await this.getManagedCompaniesStructure();
  },

  methods: {
    ...mapActions(["getShareholderStructure"]),


    async getManagedCompaniesStructure() {
      this.disabled = true
      let result = await this.getShareholderStructure();

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }

      this.managedCompanies = result.data;
      this.disabled = false
    },
  }
}
</script>
<style scoped>
.dragItem {
  cursor: move;
}

.tree-container {
  overflow-y: auto;
  max-height: 65vh;
} 
</style>
